import Cookies from "js-cookie";

function init() {
  const cookieName = 'cookie_accepted';
  const cookiebar = document.querySelector('.js-CookieBar');

  if( Cookies.get(cookieName) === '1' || !cookiebar ) {
    return;
  }

  cookiebar.removeAttribute('hidden');

  function enableAnalytics() {
    if(!window.dataLayer) return;

    window.dataLayer.push({
      'event': 'consent_given'
    });

    window.gtag('consent', 'update', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted'
    });
  }

  function setCookie() {
    Cookies.set(cookieName, 1, { expires: 30 });
  }

  function handleBtnClick(e) {
    e.preventDefault();
    setCookie();
    enableAnalytics();
    cookiebar.setAttribute('hidden', 'hidden');
  }

  function handleDocumentClick(e) {
    if(e.target.closest('a:not([data-cookie-bar-ignore]), button:not([data-cookie-bar-ignore])')) {
      setCookie();
      enableAnalytics();
    }
  }

  document.addEventListener('click', handleDocumentClick, { once: true });

  cookiebar
    .querySelector('.js-CookieBar-btn')
    .addEventListener('click', handleBtnClick);
}

init();